
























import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    Ref,
    ref,
} from '@vue/composition-api';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { authenticationService } from '@core/services/authentication/AuthenticationService';
import { intervalToDuration } from 'date-fns';

export default defineComponent({
    name: 'AccountRgInfoStats',
    props: {
        isPage: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup() {
        const { translate } = useI18n();
        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const sessionStartTime = authModule.getter('sessionStartTime');
        const sessionTime = ref('00:00:00');

        const getSessionTime = () => {
            const { hours, minutes, seconds } = intervalToDuration({ start: Date.now(), end: sessionStartTime.value || Date.now() });
            sessionTime.value = `${hours?.toString().padStart(2, '0')}:${minutes?.toString().padStart(2, '0')}:${seconds?.toString().padStart(2, '0')}`;
        };

        getSessionTime();

        const sessionNetPosition = ref('0');
        const netPositionType: Ref<'lost' | 'profit'> = ref('lost');

        const responsibleGamingInfo = computed(() => ([
            {
                type: 'time',
                label: 'pam.accountMenu.sessionTime',
                value: sessionTime.value,
            },
            {
                type: netPositionType.value,
                label: 'pam.accountMenu.sessionNetPosition',
                value: sessionNetPosition.value,
            },
        ]));

        let intervalCheck: ReturnType<typeof setInterval> | null;

        onMounted(async () => {
            if (!intervalCheck) {
                intervalCheck = setInterval(() => {
                    getSessionTime();
                }, 1000);
            }

            try {
                const { winLossAmount } = await authenticationService.getSessionStats();

                sessionNetPosition.value = winLossAmount.toFixed(2) + ' ' + translate('currencyAbbreviation');
                if (parseInt(sessionNetPosition.value, 10) > 0) {
                    netPositionType.value = 'profit';
                } else {
                    netPositionType.value = 'lost';
                }
            } catch (error) {}
        });

        onUnmounted(() => {
            if (intervalCheck) {
                clearInterval(intervalCheck);
            }
        });

        return {
            responsibleGamingInfo,
        };
    },
});

